import { render, staticRenderFns } from "./UpToDate.vue?vue&type=template&id=1049d730&scoped=true"
import script from "./UpToDate.vue?vue&type=script&lang=js"
export * from "./UpToDate.vue?vue&type=script&lang=js"
import style0 from "./UpToDate.vue?vue&type=style&index=0&id=1049d730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1049d730",
  null
  
)

export default component.exports